import styled from '@emotion/styled';

export const ExecutiveListContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem;
	}
`;
export const ExecutiveListItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const ExecutiveListTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;
export const Table = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-auto-rows: minmax(40px, auto);
`;
export const FourColumnTable = styled.div`
	display: grid;
	grid-template-columns: 1.2fr 1fr 1fr 1.4fr;
	grid-auto-rows: minmax(40px, auto);
`;
export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #00377b;
	color: white;
	padding: 10px 15px;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: 150%;
	&.center {
		justify-content: center;
	}
`;
export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
	&.point {
		color: #12539e;
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
`;
export const PositionCell = styled(TableCell)`
	color: #00377b;
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
`;
